document.addEventListener('DOMContentLoaded', () => {
	// Get all inputs with data attribute data-action=search
	const searchInputs = document.querySelectorAll('[data-action=search]');

	const doSearch = (event) => {
		const {currentTarget} = event;
		const search = currentTarget.value;
		const url = currentTarget.dataset.url;

		window.location = `${url}?s=${search}`;
	}

	// Loop over them and add event listeners
	Array.prototype.slice.call(searchInputs)
		.forEach(function (input) {
			input.addEventListener('blur', function (event) {
				doSearch(event);
			});

			input.addEventListener('keyup', function (event) {
				if (event.keyCode === 13) {
					doSearch(event);
				}
			});
		});
});